import Loading from 'components/common/loading/loading';




/*
使用方法：
1.main.js中注册
import toastRegistry from './components/common/toast/index'   ////toast弹窗组件
Vue.use(toastRegistry)    ////挂到原型链上

2,直接使用
this.$toast('我是toast弹窗')
*/
import Vue from 'vue'

// 这里就是我们刚刚创建的那个静态组件
// import toastComponent from './toast.vue'
import userLoading from './loading.vue'
// import { publicFadeInOut } from "common/tool";

// 返回一个 扩展实例构造器
const loadingConstructor = Vue.extend(userLoading)
let loadingDom = {}
// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function showLoading(type = 1, msg = '加载中...') {
    if (loadingDom.isShow === true) {
        console.log("loading已经创建过了，需要先进行关闭上一个，在创建新的")
        ///加这一句的目的时为了避免在loading已经创建了的情况下，再次创建无法关闭的BUG。这里先进行关闭上一个，在进行创建新的。
        loadingDom.isShow = false;
    }

    // 实例化一个 toast.Vue
    loadingDom = new loadingConstructor({
        el: document.createElement('div'),
        data() {
            return {
                isShow: true,
                msg: msg,
                type: type
            }
        }
    })

    // 把 实例化的 toast.Vue 添加到 body 里
    document.body.appendChild(loadingDom.$el)

}

///////////控制关闭loading
function closeLoading() {

    loadingDom.isShow = false;
}

// 注册为全局组件的函数
function UseShowLoading() {
    // 将组件注册到 Vue 的 原型链里去,
    // 这样就可以在所有 Vue 的实例里面使用 this.$toast()
    Vue.prototype.$showLoading = showLoading  ///控制显示toast的函数
}
function UseCloseLoading() {
    // 将组件注册到 Vue 的 原型链里去,
    Vue.prototype.$closeLoading = closeLoading  ///////////控制关闭toast的的函数
}

export { UseShowLoading, UseCloseLoading }
